import ComunicacionInternaService from 'src/modules/comunicacionInterna/comunicacionInternaService';
import selectors from 'src/modules/comunicacionInterna/list/comunicacionInternaListSelectors';
import {i18n} from 'src/i18n';
import exporterFields from 'src/modules/comunicacionInterna/list/comunicacionInternaListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'COMUNICACIONINTERNA_LIST';

const comunicacionInternaListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doClearAllSelected() {
    return {
      type: comunicacionInternaListActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: comunicacionInternaListActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: comunicacionInternaListActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset: () => async dispatch => {
    dispatch({
      type: comunicacionInternaListActions.RESETED,
    });

    dispatch(comunicacionInternaListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: comunicacionInternaListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await ComunicacionInternaService.list(filter, selectors.selectOrderBy(getState()), null, null);

      new Exporter(exporterFields, i18n('entities.comunicacionInterna.exporterFileName')).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: comunicacionInternaListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: comunicacionInternaListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePagination: pagination => async (dispatch, getState) => {
    dispatch({
      type: comunicacionInternaListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch(comunicacionInternaListActions.doFetchCurrentFilter());
  },

  doChangeSort: sorter => async (dispatch, getState) => {
    dispatch({
      type: comunicacionInternaListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(comunicacionInternaListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (dispatch, getState) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(comunicacionInternaListActions.doFetch(filter, rawFilter, true));
  },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: comunicacionInternaListActions.FETCH_STARTED,
          payload: {filter, rawFilter, keepPagination},
        });

        const response = await ComunicacionInternaService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );
        console.log('%c⧭ doFetch', 'color: #d0bfff', {response});

        dispatch({
          type: comunicacionInternaListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: comunicacionInternaListActions.FETCH_ERROR,
        });
      }
    },
};

export default comunicacionInternaListActions;
